import React, { useEffect, useState } from 'react';
import VerificationCode from './VerificationCode';
import useUser from '../../stores/useUser';
import Success from './Success';
import WelcomeText from './WelcomeText';
import { IModalProps } from './Modal';
import trackApi from '../../utils/trackApi';


const ModalSteps: React.FC<React.PropsWithChildren<IModalProps>> = ({ userMail, onChange, isLoading, onClose, onSubmitAction, formElement, submitButtonText, successText, pass, trackingSteps }) => {
    const [user] = useUser();
    const [modalStep, setModalStep] = useState(1);
    const [mail, setMail] = useState('');
    const [salt, setSalt] = useState('');
    const [code, setCode] = useState('');
    const values = { mail, salt, code };

    useEffect(() => {
        /**
        * Tracking
        */
        if (trackingSteps) {
            const baseUrl = `${window.location.protocol}//${window.location.hostname}`;

            trackApi.wglPageview(
                trackingSteps[modalStep - 1].virtPath,
                trackingSteps[modalStep - 1].virtTitle,
                {
                    virtLocation: baseUrl + trackingSteps[modalStep - 1].virtLocation,
                    virtReferrer: baseUrl + trackingSteps[modalStep - 1].virtReferrer

                });
        } else {
            console.debug('no tracking for step', nextStep);
        }

    }, [modalStep]);

    const prevStep = () => {
        setModalStep(modalStep - 1);
    }

    const nextStep = () => {
        setModalStep(modalStep + 1);
    }

    const handleCodeChange = (event) => {
        setCode(event.target.value);
    };

    useEffect(() => {
        setMail(userMail);
    }, []);

    switch (modalStep) {
        case 1:
            return (
                <WelcomeText
                    nextStep={nextStep}
                    values={values}
                    setSalt={setSalt}
                    setCode={setCode}
                />
            )
        case 2:
            return (
                <VerificationCode
                    prevStep={prevStep}
                    nextStep={nextStep}
                    values={values}
                    handleCodeChange={handleCodeChange}
                    setSalt={setSalt}
                    setCode={setCode}
                    onSubmitAction={onSubmitAction}
                    salt={salt}
                    code={code}
                    pass={pass}
                    trackingSteps={trackingSteps}
                />
            )
        case 3:
            return (
                <Success
                    onChange={onChange}
                    isLoading={isLoading}
                    values={values}
                    onClose={onClose}
                    onSubmitAction={onSubmitAction}
                    formElement={formElement}
                    submitButtonText={submitButtonText}
                    successText={successText}
                    salt={salt}
                    code={code}
                />
            )
        default:
        // do nothing
    }

}
export default ModalSteps;